import { render } from "./ListeCessionPage.vue?vue&type=template&id=08631222&ts=true"
import script from "./ListeCessionPage.vue?vue&type=script&lang=ts"
export * from "./ListeCessionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__